import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/nl';
import 'moment/locale/fr';
import 'moment/locale/it';

const WeightCalculator = () => {
    return {
        startWeight: 100,
        targetWeight: 75,
        estimatedStartDate: '',
        estimatedEndDate: '',
        currentDate: '',
        daysToEstimatedEndDate: 0,
        weightUnit: '',
        weightMultiplier: 7000,
        weightDivider: 3200,

        init(language) {
            switch (language) {
                case 'uk_UK':
                    this.weightUnit = 'st';
                    this.startWeight = '15.7';
                    this.targetWeight = '12.5';
                    this.weightDivider = 1100;

                    moment.locale('en-gb');
                    break;
                case 'nl_NL':
                    moment.locale('nl');
                    break;
                case 'fr_FR':
                    moment.locale('fr');
                    break;
                case 'it_IT':
                    moment.locale('it');
                    break;
                default:
                    moment.locale('de');
                    this.weightUnit = 'kg';
            }

            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('startWeight') && isNaN(parseFloat(urlParams.get('startWeight'))) !== true) {
                this.startWeight = parseFloat(urlParams.get('startWeight'));
            }
            if (urlParams.has('targetWeight') && isNaN(parseFloat(urlParams.get('targetWeight'))) !== true) {
                this.targetWeight = parseFloat(urlParams.get('targetWeight'));
            }

            this.daysToEstimatedEndDate = Math.round((this.startWeight - this.targetWeight) * this.weightMultiplier / this.weightDivider);

            let estimatedEndDate = moment().add(this.daysToEstimatedEndDate, 'days');
            this.estimatedEndDate = estimatedEndDate.format('Do MMMM YYYY');

            let estimatedStartDate = moment(estimatedEndDate).subtract(7, 'days');
            this.estimatedStartDate = estimatedStartDate.format('Do MMMM YYYY');

            this.currentDate = moment().format('Do MMMM YYYY');
        },

        whichPackage() {
            switch (true) {
                case this.daysToEstimatedEndDate >= 1 && this.daysToEstimatedEndDate <= 29:
                    return 1;
                case this.daysToEstimatedEndDate >= 30 && this.daysToEstimatedEndDate <= 44:
                    return 2;
                case this.daysToEstimatedEndDate > 44:
                    return 3;
                default:
                    return 3;
            }
        },

        difference() {
            const result = this.startWeight - this.targetWeight;

            if (result < 0) {
                return 0;
            }

            if (Number.isInteger(result)) {
                return result;
            } else {
                return (this.startWeight - this.targetWeight).toFixed(1);
            }
        }
    }
}

window.weightCalculator = WeightCalculator;
